module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('header-bar'), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('el-row', {
    staticClass: "flex"
  }, [_c('el-col', {
    staticClass: "l-menu",
    attrs: {
      "xs": 24,
      "sm": 3,
      "md": 3,
      "lg": 3
    }
  }, [_c('main-menu')], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 21,
      "md": 21,
      "lg": 21
    }
  }, [_c('div', {
    staticClass: "grid-content r-con",
    staticStyle: {
      "background-color": "#F5F5F5"
    }
  }, [_c('router-view')], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d5ca1f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = 680
// module chunks = 1